import './styles/ClientRetrievalVerificationCodeStyle.css';
import React, { useCallback, useEffect, useState } from 'react';
import {
  ControlledNumericInput,
  NavigationButton,
  NumPad,
  ToastType,
  TopNav,
  TopNavToastMessage,
} from '../common';
import { languageMap } from '../../maps/languageMap';
import { useActions, useTypedSelector } from '../../hooks';
import { APIResponseStatusType, navigationPages } from '../../models/types';
import { apiErrorHandler, apiPOST } from '../../restApi';
import { useHistory } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import CodeImage from '../../resources/images/verificationCode.png';
import {
  ExitValidationRequestPOST,
  ExitValidationResponsePOST,
} from '../../models/cruds';
import { BsFillPersonFill } from 'react-icons/bs';

const CODE_VALID_LENGTH = 8;
const CODE_FEEDBACK_LENGTH = 'El código de verificación es de 8 caractéres';
const CODE_INCORRECT = 'El código de verificación que ingresaste es incorrecto';
const API_VALIDATION_ERROR = 'Error en la consulta';

const ClientRetrievalVerificationCode: React.FC = () => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [verficationCode, setVerficationCode] = useState('');
  const [qrCode, setQRCode] = useState('');
  const [variableInError, setVariableInError] = useState('');
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const token = useTypedSelector(({ session }) => {
    return session.dhlApiToken;
  });
  const currentLockerPosition = useTypedSelector(({ locker }) => {
    return locker.currentLockerPosition;
  });
  const isMultiDelivery = useTypedSelector(({ locker }) => {
    return locker.isMultiDelivery;
  });
  const customerName = useTypedSelector(({ locker }) => {
    return locker.customerName;
  });
  const scanner = useTypedSelector(({ devices }) => {
    return devices.scanner;
  });
  const { lockerReset } = useActions();
  useEffect(() => {
    if (scanner) {
      scanner?.pullTriggerAsync().catch((error) => console.error(error));
    }
    let timer = setInterval(() => {
      if (scanner) {
        scanner?.pullTriggerAsync().catch((error) => console.error(error));
      }
    }, 4000);
    return () => clearTimeout(timer);
  }, [scanner]);
  useEffect(() => {
    if (scanner) {
      scanner?.pullTriggerAsync().catch((error) => console.error(error));
    }
    let timer = setInterval(() => {
      if (scanner) {
        scanner?.pullTriggerAsync().catch((error) => console.error(error));
      }
    }, 4000);
    return () => clearTimeout(timer);
  }, [scanner]);
  const onScan = useCallback(
    (event: CustomEvent) => {
      console.log(event);
      if (!loading && event.detail) {
        let filteredScan = event.detail.replace('\n', '');
        filteredScan = filteredScan.replace('\r', '');
        if (filteredScan.length === CODE_VALID_LENGTH) {
          setQRCode(filteredScan);
        }
        let timer = setTimeout(() => {
          scanner?.pullTriggerAsync().catch((error) => console.error(error));
        }, 2000);
        return () => clearTimeout(timer);
      }
    },
    [loading, scanner]
  );
  useEffect(() => {
    const addScannerEventListeners = () => {
      scanner?.addEventListener('scan', onScan as EventListener);
    };
    addScannerEventListeners();
  }, [scanner, onScan]);
  useEffect(
    () => () => {
      const removeScannerEventListeners = () => {
        scanner?.removeEventListener('scan', onScan as EventListener);
      };
      removeScannerEventListeners();
    },
    [scanner, onScan]
  );
  useEffect(() => {
    if (!loading && qrCode !== '') {
      requestCodeValidation();
    }
  }, [loading, qrCode]);
  const validateCode = async (
    awbNumber: string,
    code: string,
    qr: string
  ): Promise<boolean> => {
    let request = new ExitValidationRequestPOST();
    let response: ExitValidationResponsePOST = await apiPOST(
      request.buildURL(),
      request.generateContent(awbNumber, code, qr),
      request.generateConfig(token)
    );
    let errorMsg = '';
    try {
      if (response.status === APIResponseStatusType.SUCCESS) {
        if (response.data.exitValidation) {
          let content = response.data.exitValidation;
          let positionWithAWB = content.packageCandidate.awbNumber;
          if (positionWithAWB === awbNumber) {
            return true;
          } else {
            setFeedbackMessage(CODE_INCORRECT);
            return false;
          }
        } else {
          //TODO check for unauth and refresh token
          errorMsg = 'Unauthorized';
        }
      } else {
        errorMsg = apiErrorHandler(response);
      }
    } catch (err: any) {
      errorMsg = err.toString();
    }
    console.log(errorMsg);
    setFeedbackMessage(API_VALIDATION_ERROR);
    return false;
  };
  const requestCodeValidation = async () => {
    if (qrCode === '') {
      if (verficationCode.length < CODE_VALID_LENGTH) {
        setFeedbackMessage(CODE_FEEDBACK_LENGTH);
        return;
      }
    }
    let awb = currentLockerPosition?.packageCandidate?.awbNumber ?? '';
    setLoading(true);
    if (await validateCode(awb, verficationCode, qrCode)) {
      if (isMultiDelivery) {
        history.replace(`/${navigationPages.CLIENT_RETRIEVAL_PIECE}`);
      } else {
        history.replace(`/${navigationPages.CLIENT_RETRIEVAL_NAME}`);
      }
    }
    setQRCode('');
    setLoading(false);
  };
  const handleKeypress = (e: any) => {
    //it triggers by pressing the enter key
    if (e.key === 'Enter') {
      requestCodeValidation();
    }
  };
  const handleNumPad = (option: string) => {
    setFeedbackMessage('');
    //it triggers by pressing the enter key
    if (option === 'go') {
      requestCodeValidation();
      return;
    }
    if (option === 'back') {
      setVerficationCode(verficationCode.slice(0, -1));
      return;
    }
    if (verficationCode.length < CODE_VALID_LENGTH) {
      setVerficationCode(verficationCode + option);
    } else {
      setFeedbackMessage(CODE_FEEDBACK_LENGTH);
    }
  };
  const renderNumpad = () => {
    if (loading) {
      return (
        <div className="client-retrieval-scan-numpad-container">
          <div className="spinner-container">
            <Spinner className="spinner" animation="grow" variant="danger" />
          </div>
        </div>
      );
    }
    return (
      <div className="client-retrieval-scan-numpad-container">
        <NumPad
          onClickButton={(option) => {
            handleNumPad(option);
          }}
        />
      </div>
    );
  };
  const renderContent = () => {
    return (
      <div className="locker-content-container">
        <div className="locker-content-container-left">
          <div className="client-retrieval-scan-code-container">
            <ControlledNumericInput
              val={verficationCode}
              inputLabel="Código de verificación"
              inputPlaceholder="12345678"
              validationError={variableInError === 'verficationCode'}
              maxLength={10}
              maxNumber={9999999999}
              disabled={loading}
              type="integer"
              inputType="password"
              onError={(isErr: boolean) => {
                if (isErr) {
                  let msg = languageMap.login.installation_id_error[language];
                  setVariableInError('verficationCode');
                  setFeedbackMessage(msg);
                } else {
                  setFeedbackMessage('');
                  setVariableInError('');
                }
              }}
              onTextChange={(newVal: string) => {
                setVariableInError('');
                setFeedbackMessage('');
                setVerficationCode(newVal);
              }}
              handleKeypress={handleKeypress}
              extraClassContainer="no-padding-right full-width stretched"
              extraClass="placeholder-left"
            />

            <div className="scan-code-image-awb-container">
              <img
                id="code-image"
                className="code-image"
                src={CodeImage}
                alt="Code"
              />
            </div>
          </div>
        </div>
        <div className="locker-content-container-right">{renderNumpad()}</div>
      </div>
    );
  };
  const renderButtonContent = () => {
    return (
      <div className="not-me-button-content">
        <BsFillPersonFill className="not-me-button-icon" />
        {languageMap.client_retrieval_scan_awb.not_me[language]}
      </div>
    );
  };
  const renderCustomerInfo = () => {
    if (customerName !== '') {
      return (
        <p className="subtitle nopadding horizontal pascal nomargin">
          {customerName.toLocaleLowerCase()}
          <NavigationButton
            buttonContent={renderButtonContent()}
            buttonClass="default-button not-me-button"
            onClickButton={() => {
              lockerReset();
              history.replace(`/${navigationPages.CLIENT_RETRIEVAL_SCAN_AWB}`);
            }}
          />
        </p>
      );
    }
  };
  return (
    <div id="clientRetrievalVerificationCode" className="main-container">
      <TopNav dataCyPrefix="scan-awb" />
      <div className="content-container">
        <div className="main-content-container fullpage">
          <TopNavToastMessage
            toastText={feedbackMessage}
            toastType={ToastType.ERROR}
            resetMessage={() => setFeedbackMessage('')}
          />
          <div className="title-content-container vertical">
            <p className="header nopadding nomargin">
              {languageMap.client_retrieval_verification_code.title[language]}
            </p>
            {renderCustomerInfo()}
          </div>
          <div className="data-content-container">{renderContent()}</div>
          <div className="footer-container">
            <div className="footer-button-container">
              <NavigationButton
                buttonContent={
                  languageMap.client_retrieval_scan_awb.back_button[language]
                }
                buttonClass="navigation-button cancel-button complete"
                onClickButton={() => {
                  history.replace(
                    `/${navigationPages.CLIENT_RETRIEVAL_SCAN_AWB}`
                  );
                }}
              />
            </div>
            <div className="footer-button-container" />
          </div>
        </div>
      </div>
    </div>
  );
};

export { ClientRetrievalVerificationCode };
